import { createI18n } from 'vue-i18n'

import dn from './dn.json'
import tidtiltur from './tidtiltur.json'
import affaldsindsamlingen from './affaldsindsamlingen.json'
import naturensuge from './naturensuge.json'


const dictionaries = {
    dn: dn,
    tidtiltur: tidtiltur,
    affaldsindsamlingen: affaldsindsamlingen,
    naturensuge:naturensuge
}

const i18n = createI18n({
    locale: 'dn',
    messages: Object.assign(dictionaries)
})

export default i18n
